import React from 'react';

const Privacy = () => {
    return (
        <div className="page-content page-top">
            <div className="container-medium">
                <div className="page-header">
                    <h1 className="page-title">Privacy Policy</h1>
                    <p className="text-muted">Last Updated: February 10, 2026</p>
                </div>
                <div className="content-card legal-content">

                    <section className="legal-section">
                        <h2>1. Information We Collect</h2>
                        <p>We collect information that you provide directly to us when using our TikTok Shop
                            management
                            platform, including:</p>
                        <ul>
                            <li>Account information (name, email, business details)</li>
                            <li>TikTok Shop data accessed through API integration</li>
                            <li>Order and product information</li>
                            <li>Analytics and usage data</li>
                        </ul>
                    </section>

                    <section className="legal-section">
                        <h2>2. How We Use Your Information</h2>
                        <p>We use the collected information to:</p>
                        <ul>
                            <li>Provide and maintain our services</li>
                            <li>Process transactions and manage your orders</li>
                            <li>Send you technical notices and support messages</li>
                            <li>Analyze usage patterns to improve our platform</li>
                            <li>Comply with legal obligations</li>
                        </ul>
                    </section>

                    <section className="legal-section">
                        <h2>3. Data Security</h2>
                        <p>We implement industry-standard security measures to protect your data, including
                            encryption,
                            secure servers, and regular security audits. However, no method of transmission over the
                            Internet is 100% secure, and we cannot guarantee absolute security.</p>
                    </section>

                    <section className="legal-section">
                        <h2>4. Third-Party Services</h2>
                        <p>Our platform integrates with TikTok Shop APIs and other third-party services. These
                            services
                            have their own privacy policies, and we encourage you to review them.</p>
                    </section>

                    <section className="legal-section">
                        <h2>5. Legal Basis and User Consent</h2>
                        <p>By using our platform, you consent to the collection and use of your personal information
                            as
                            described in this Privacy Policy. You may withdraw your consent at any time.</p>
                    </section>

                    <section className="legal-section">
                        <h2>6. Cookies and Behavioral Tracking</h2>
                        <p>Our platform uses cookies and similar technologies to improve user experience and analyze
                            usage. You can manage your cookie preferences in your browser settings.</p>
                    </section>

                    <section className="legal-section">
                        <h2>7. Data retention and deletion</h2>
                        <p>We retain your personal data only as long as necessary for the purposes described. You
                            may
                            request deletion of your data at any time by contacting us.</p>
                    </section>

                    <section className="legal-section">
                        <h2>8. Third-party sharing</h2>
                        <p>We may share your data with third-party service providers for order processing, payment,
                            logistics, and analytics. These parties are bound to protect your data in accordance
                            with
                            this Privacy Policy.</p>
                    </section>

                    <section className="legal-section">
                        <h2>9. Regulatory authorities and complaints</h2>
                        <p>You have the right to lodge a complaint with your local data protection authority if you
                            believe your rights have been violated.</p>
                    </section>

                    <section className="legal-section">
                        <h2>10. Your Rights</h2>
                        <p>You have the right to:</p>
                        <ul>
                            <li>Access your personal data</li>
                            <li>Correct inaccurate data</li>
                            <li>Request deletion of your data</li>
                            <li>Object to processing of your data</li>
                            <li>Export your data</li>
                        </ul>
                    </section>

                    <section className="legal-section">
                        <h2>11. Contact Us</h2>
                        <p>If you have questions about this Privacy Policy, please contact us at{' '}
                            <a href="mailto:service@xndeals.online"
                               className="text-link">service@xndeals.online</a>
                        </p>
                    </section>

                </div>
            </div>
        </div>
    );
};

export default Privacy;
